import React, {useEffect} from "react";
import {ChatThemeProvider} from "@unibuddy/chat-ui";

import {useAssistantInitiationContext} from "./providers/AssistantInitiationProvider";
import {ChatLoadingMessages} from "./components/ChatLoadingMessages";
import {ChatMessages} from "./components/ChatMessages";
import {chatTheme} from "../../utils/theme/chatTheme";
import {ChatHeader} from "./components/ChatHeader/ChatHeader";
import {StandaloneChatWrapper} from "./components/StandaloneChatWrapper/StandaloneChatWrapper";
import {useMarkConversationAsViewed} from "./hooks/useMarkConversationAsViewed";
import {useUniversityContext} from "../../providers/UniversityProvider";

export function Chat() {
    const {universityId} = useUniversityContext();
    const {loading, conversationId, token} = useAssistantInitiationContext();
    const {markConversationAsViewed} = useMarkConversationAsViewed();

    useEffect(() => {
        if (conversationId && universityId) {
            markConversationAsViewed({conversationId, universityId, token});
        }
    }, [conversationId, markConversationAsViewed, universityId, token]);

    return (
        <StandaloneChatWrapper>
            <ChatThemeProvider
                theme={
                    // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
                    chatTheme as any
                }
            >
                <ChatHeader />
                {loading ? <ChatLoadingMessages /> : <ChatMessages />}
            </ChatThemeProvider>
        </StandaloneChatWrapper>
    );
}
